/**
 * Recent Referrals Component
 * Display list of recent referrals
 */

interface Referral {
  id: number;
  clientEmail: string;
  converted: number;
  convertedAt: string | null;
  createdAt: string;
  orderId: number | null;
}

interface RecentReferralsProps {
  referrals: Referral[];
}

export default function RecentReferrals({ referrals }: RecentReferralsProps) {
  if (referrals.length === 0) {
    return (
      <div className="text-center py-8">
        <svg
          className="w-16 h-16 text-gray-600 mx-auto mb-4"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
        <p className="text-gray-400">No referrals yet</p>
        <p className="text-sm text-gray-500 mt-1">
          Start sharing your referral links to earn commissions
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {referrals.map((referral) => (
        <div
          key={referral.id}
          className="flex items-center justify-between p-3 bg-gray-700/50 rounded-lg hover:bg-gray-700 transition"
        >
          <div className="flex-1">
            <div className="flex items-center space-x-2">
              <p className="text-white font-medium">{referral.clientEmail}</p>
              {referral.converted === 1 && (
                <span className="px-2 py-0.5 text-xs bg-green-900/30 text-green-400 rounded-full">
                  Converted
                </span>
              )}
            </div>
            <div className="flex items-center space-x-4 mt-1 text-sm text-gray-400">
              <span>
                {new Date(referral.createdAt).toLocaleDateString()}
              </span>
              {referral.converted === 1 && referral.convertedAt && (
                <span className="flex items-center space-x-1">
                  <svg
                    className="w-4 h-4 text-green-400"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path d="M5 13l4 4L19 7" />
                  </svg>
                  <span>
                    Converted {new Date(referral.convertedAt).toLocaleDateString()}
                  </span>
                </span>
              )}
            </div>
          </div>
          <div className="text-right">
            {referral.converted === 1 ? (
              <div className="w-10 h-10 bg-green-900/30 rounded-full flex items-center justify-center">
                <svg
                  className="w-6 h-6 text-green-400"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M5 13l4 4L19 7" />
                </svg>
              </div>
            ) : (
              <div className="w-10 h-10 bg-yellow-900/30 rounded-full flex items-center justify-center">
                <svg
                  className="w-6 h-6 text-yellow-400"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
